import React, { useState, VFC, FocusEvent, ChangeEvent } from "react";

import { ValueFieldProps } from "@sitecore-jss/sitecore-jss-react-forms/types";
import { MultiLineStringInputViewModel } from "@sitecore-jss/sitecore-jss-forms";

const MultipleLineTextField: VFC<
  ValueFieldProps<MultiLineStringInputViewModel>
> = (props) => {
  console.log('textarea props ---> ', props);
  const { field, tracker } = props;
  const [hasFocus, setHasFocus] = useState(false);
  const hasValueOrFocus = hasFocus || props.value !== "";
  const hasAnyError = !!props.errors?.length;
  const label = field.model.title;
  const id = field.valueField.id;
  const name = field.valueField.name;
  const rows = field.model.rows;
  const cssClass = field.model.cssClass;
  const maxLength = field.model.maxLength ? field.model.maxLength : 255;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;

  const onFocus = (e: FocusEvent<HTMLTextAreaElement>) => {
    tracker.onFocusField(field, e.target.value);
    setHasFocus(true);
  };

  const onBlur = (e: FocusEvent<HTMLTextAreaElement>) => {
    tracker.onBlurField(field, e.target.value);
    setHasFocus(false);
  };

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange(field.valueField.name, e.target.value, props.isValid, []);
  };

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        hasAnyError ? "sitecore-jss-form__control--has-error" : ""
      }`}
    >
      <label
        htmlFor={id}
        className={`sitecore-jss-form__label ${
          hasValueOrFocus ? "sitecore-jss-form__label--has-focus" : ""
        }`}
      >
        {label}
      </label>
      <textarea
        rows={rows}
        maxLength={maxLength}
        id={id}
        name={name}
        className={"sitecore-jss-form__field sitecore-jss-form__field--text-area " + cssClass}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
      >
        {props.value}
      </textarea>
      <FieldValidationErrors {...props} />
    </div>
  );
};

export default MultipleLineTextField;
